/*******************************************************************************
 * Copyright (c) 2025 Passport Fintech Inc. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoggedInGuard} from '@common-core/guards/logged-in/logged-in.guard';
import {LoggedOutGuard} from '@common-core/guards/logged-out/logged-out.guard';

/**
 * This file is used for routing.
 */
const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('@shared/modules/auth/auth.module').then(m => m.AuthModule),
    canActivate: [LoggedOutGuard],
  },
  {
    path: '',
    loadChildren: () =>
      import('@paas-modules/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [LoggedInGuard],
  },
  {
    path: 'privacy',
    loadChildren: () =>
      import('./modules/privacy-policy/privacy-policy.component').then(
        m => m.PrivacyPolicyComponent
      ),
  },
  {
    path: 'terms',
    loadChildren: () =>
      import('./modules/terms-conditions/terms-conditions.component').then(
        m => m.TermsConditionsComponent
      ),
  },
  {
    path: 'release-notes',
    loadChildren: () =>
      import('@shared/modules/release-notes/release-notes.module').then(
        m => m.ReleaseNotesModule
      ),
  },
  {
    path: '**',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRouting {}
